// V1.5 Signal Link tuning per docs/02_GAME_DESIGN.md §11 Option A.
//
// Connectivity rule: a player's owned relay is "connected" iff there exists a
// path from the relay to the player's Core through other owned relays where
// each adjacent pair is within SIGNAL_LINK_RANGE_PX of each other.
//
// Range tuning for the Foundry layout:
//   Core 0 (1000, 220) — north relay (1000, 600): 380 px ✓
//   north relay     — mid relay   (1000, 1000): 400 px ✓
//   mid relay       — south relay (1000, 1400): 400 px ✓
//   south relay     — Core 1     (1000, 1780): 380 px ✓
//   Core 0          — mid relay              : 780 px ✗  (must hop)
//   north           — south                  : 800 px ✗  (must hop through mid)
//
// 500 px historically connected Foundry's adjacent pair while forcing the
// mid relay to be reached through a hop. V1.5+ Crucible (3000×2400, 7-relay
// graph) needs more headroom: home → mid spans 650 px so the chain still hops
// but the larger map's geometry has room to breathe. 700 px is the smallest
// value that supports the Crucible graph AND keeps the §11 "no lone-wolf mid
// claim" rule intact on every existing map (Vault & Canyon: core ↔ mid = 780
// px > 700, so they still must hop through a near relay).
export const SIGNAL_LINK_RANGE_PX = 700;
export const SIGNAL_LINK_RANGE_SQ = SIGNAL_LINK_RANGE_PX * SIGNAL_LINK_RANGE_PX;

// Option A — full vs. reduced. Connected = full income + vision (the V0.x
// baseline); isolated = reduced income, no vision. Income multiplier here
// applies to the relay's `generatesSignal` only (not the base trickle, not the
// dominion bonus). 0.5 = "still trickling, not dormant" — Rule 17 (no
// turtling) and §11 ("must not punish the casual player so heavily that one
// cut feels unrecoverable") both want the rate non-zero. Vision is binary:
// isolated relays don't stamp vision at all.
export const ISOLATED_INCOME_MULT = 0.5;
